<template>
  <div class="relative bg-[#0f172a] overflow-x-hidden">
    <main>
      <section class="relative py-24 sm:py-32">

        <!-- Subtle Background Glow -->
        <div
          class="absolute inset-0 -z-10 flex justify-center items-start opacity-20 blur-3xl"
          aria-hidden="true"
        >
          <div
            class="w-[60rem] h-[30rem] bg-gradient-to-tr
                   from-blue-600 via-blue-400 to-yellow-400"
            style="clip-path: polygon(20% 0%, 80% 0%, 100% 60%, 50% 100%, 0% 60%)"
          ></div>
        </div>

        <!-- Content -->
        <div class="mx-auto max-w-7xl px-6 lg:px-8">

          <!-- Header -->
          <div>
            <span class="text-xs tracking-[0.35em] font-semibold text-yellow-400">
              PARTNERSHIPS
            </span>

            <h2 class="mt-6 text-3xl sm:text-4xl font-extrabold text-white">
              Our Clients & Strategic Partners
            </h2>

            <p class="mt-6 text-lg leading-8 text-gray-300">
              Oillead Integrated Services Ventures Limited (OLS) collaborates with leading operators, EPC
              contractors, and industrial organizations across Africa and
              internationally. Our partnerships reflect our commitment to
              engineering excellence, safety, and sustainable project delivery.
            </p>

            <!-- CTA 
            <div class="mt-10">
              <a
                href="#"
                class="inline-flex items-center gap-2
                       rounded-full bg-yellow-400
                       px-8 py-3 text-sm font-semibold text-slate-900
                       shadow-lg hover:bg-yellow-300 transition"
              >
                View All Clients →
              </a>
            </div> -->
          </div>

          <!-- Logos -->
          <div
            class="mt-20 grid grid-cols-2 gap-x-8 gap-y-12
                   sm:grid-cols-3 lg:grid-cols-5"
          >
            <div
              v-for="(client, index) in clients"
              :key="index"
              class="flex items-center justify-center rounded-2xl
                     bg-white p-5 shadow-md ring-1 ring-black/5
                     hover:shadow-xl transition"
            >
              <img
                :src="client.src"
                :alt="client.alt"
                class="max-h-10 w-full object-contain transition"
              /> 
            </div>
          </div>

        </div>
      </section>
    </main>
  </div>
</template>

<script>
import exxon from '../assets/ourclients_exxonmobil.png'
import crestech from '../assets/ourclients_crestech.png'
import oceon from '../assets/ourclients_oceon.png'
import utiebe from '../assets/utiebe.png'
import netco from '../assets/ourclients_NETCO.png'
import nnpc from '../assets/ourclients_NNPC.png'
import bua from '../assets/ourclients_BUA.png'
import npd from '../assets/ourclients_NPD.png'
import amazon from '../assets/ourclients_amazonenergy.png'
import panocean from '../assets/ourclients_panocean.png'
import total from '../assets/ourclients_Total.png'

export default {
  data() {
    return {
      clients: [
        { src: exxon, alt: 'ExxonMobil' },
        { src: crestech, alt: 'Crestech' },
        { src: oceon, alt: 'Oceon' },
        { src: utiebe, alt: 'Utiebe' },
        { src: netco, alt: 'NETCO' },
        { src: nnpc, alt: 'NNPC' },
        { src: bua, alt: 'BUA' },
        { src: npd, alt: 'NPD' },
        { src: amazon, alt: 'Amazon Energy' },
        { src: panocean, alt: 'PanOcean' },
        { src: total, alt: 'TotalEnergies' }
      ]
    }
  }
}
</script>